<template>
  <DashboardWidget class="no-overflow" canGoFullscreen :loading="loading" title="KPI - Key Performance Index">
    <OperativeTable dense>
      <tbody>
      <OperativeTableBodyRowKpi :values="[{ rank: kpi.scoringStrutturaFinanziaria }]">Scoring struttura finanziaria</OperativeTableBodyRowKpi>
      <OperativeTableBodyRowKpi :values="[{ rank: kpi.scoringCicloFinanziario }]">Scoring ciclo finanziario</OperativeTableBodyRowKpi>
      <OperativeTableBodyRowKpi :values="[{ rank: kpi.scoringAndamentoEconomico }]">Scoring andamento economico</OperativeTableBodyRowKpi>
      <OperativeTableBodyRowKpi :values="[{ rank: kpi.scoringLeverage }]">Scoring leverage</OperativeTableBodyRowKpi>
      <OperativeTableBodyRowKpi :values="[{ rank: kpi.scoringEquilibrioStrutturaAziendale }]">Scoring equilibrio della struttura aziendale</OperativeTableBodyRowKpi>
      <OperativeTableBodyRowKpiZScore :values="[{ rank: kpi.scoringZScore }]">Z-Score</OperativeTableBodyRowKpiZScore>
      <OperativeTableBodyRowKpiRating :values="[{ rank: kpi.rating }]">Rating</OperativeTableBodyRowKpiRating>
      </tbody>
    </OperativeTable>

    <template #fullscreen>
      <OperativeTable>
        <tbody>
        <OperativeTableBodyRowKpi :values="[{ rank: kpi.scoringStrutturaFinanziaria }]">Scoring struttura finanziaria</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="[{ rank: kpi.scoringCicloFinanziario }]">Scoring ciclo finanziario</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="[{ rank: kpi.scoringAndamentoEconomico }]">Scoring andamento economico</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="[{ rank: kpi.scoringLeverage }]">Scoring leverage</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="[{ rank: kpi.scoringEquilibrioStrutturaAziendale }]">Scoring equilibrio della struttura aziendale</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpiZScore :values="[{ rank: kpi.scoringZScore }]">Z-Score</OperativeTableBodyRowKpiZScore>
        <OperativeTableBodyRowKpiRating :values="[{ rank: kpi.rating }]">Rating</OperativeTableBodyRowKpiRating>
        </tbody>
      </OperativeTable>
    </template>
  </DashboardWidget>
</template>

<script>

export default {
  name: 'dashboard-widget-kpi',
  components: {
    DashboardWidget: () => import('./DashboardWidget'),
    OperativeTable: () => import('../../Operative/OperativeTable'),
    OperativeTableBodyRowKpi: () => import('../../Operative/Kpi/OperativeTableBodyRowKpi'),
    OperativeTableBodyRowKpiZScore: () => import('../../Operative/Kpi/OperativeTableBodyRowKpiZScore'),
    OperativeTableBodyRowKpiRating: () => import('../../Operative/Kpi/OperativeTableBodyRowKpiRating'),
  },
  props: {
    kpi: {
      type: Object,
    },
  },
  data () {
    return {
      loading: false,
    };
  },
};

</script>

<style lang="scss"></style>
